import * as React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { styled } from "@mui/material/styles";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";

const NestedListItem = styled(ListItem)(
  ({ theme, isSubItem, selected, isMobile }) => ({
    paddingLeft: theme.spacing(
      isSubItem ? (isMobile ? 3 : 4) : isMobile ? 1 : 2
    ),
    paddingRight: theme.spacing(isMobile ? 1 : 2),
    paddingTop: theme.spacing(isMobile ? 0.5 : 1),
    paddingBottom: theme.spacing(isMobile ? 0.5 : 1),
    backgroundColor: selected
      ? "rgba(255, 255, 255, 0.2)"
      : isSubItem
      ? "transparent"
      : "rgba(255, 255, 255, 0.05)",
    "&:hover": {
      backgroundColor: selected
        ? "rgba(255, 255, 255, 0.3)"
        : "rgba(255, 255, 255, 0.1)",
    },
    color: "white",
    borderRadius: theme.spacing(isMobile ? 0.5 : 1),
    margin: theme.spacing(0.25, isMobile ? 0.5 : 1),
    transition: theme.transitions.create(["background-color", "transform"], {
      duration: theme.transitions.duration.short,
    }),
    "&:active": {
      transform: "scale(0.98)",
    },
  })
);

const StyledListItemButton = styled(ListItemButton)(
  ({ theme, selected, isOpen, isMobile }) => ({
    minHeight: isMobile ? 48 : 52,
    paddingLeft: theme.spacing(isMobile ? 1 : 2),
    paddingRight: theme.spacing(isMobile ? 1 : 2),
    backgroundColor: selected
      ? "rgba(255, 255, 255, 0.15)"
      : "rgba(255, 255, 255, 0.05)",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.2)",
    },
    borderRadius: theme.spacing(isMobile ? 0.5 : 1),
    margin: theme.spacing(0.25, isMobile ? 0.5 : 1),
    transition: theme.transitions.create(["background-color", "transform"], {
      duration: theme.transitions.duration.short,
    }),
    "&:active": {
      transform: "scale(0.98)",
    },
  })
);

const SidebarMenu = ({ route, isOpen, isMobile, onNavigate }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();

  const isActive =
    route.subRoutes?.some((subRoute) =>
      location.pathname.includes(subRoute.path)
    ) || false;

  const [open, setOpen] = React.useState(isActive);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleSubRouteClick = (path) => {
    navigate(path);
    // Close drawer on mobile after navigation
    if (isMobile && onNavigate) {
      onNavigate();
    }
  };

  return (
    <>
      <ListItemButton onClick={handleClick} selected={isActive}>
        <ListItemIcon sx={{ color: "white", minWidth: 40 }}>
          {route.icon}
        </ListItemIcon>
        <ListItemText
          primary={route.name}
          sx={{
            color: "white",
            opacity: isOpen ? 1 : 0,
            "& .MuiTypography-root": {
              fontSize: "14px",
            },
          }}
        />
        {isOpen && (
          <>
            {open ? (
              <ExpandLess sx={{ color: "white" }} />
            ) : (
              <ExpandMore sx={{ color: "white" }} />
            )}
          </>
        )}
      </ListItemButton>
      <Collapse in={open && isOpen} timeout="auto" unmountOnExit>
        {route.subRoutes?.map((subRoute, index) => (
          <NestedListItem
            key={index}
            button
            component="div"
            onClick={() => handleSubRouteClick(subRoute.path)}
            isSubItem
            selected={location.pathname.includes(subRoute.path)}
            isMobile={isMobile}
          >
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemIcon sx={{ color: "white", minWidth: 32 }}>
                {subRoute.icon}
              </ListItemIcon>
              <ListItemText
                primary={subRoute.name}
                sx={{
                  color: "white",
                  "& .MuiTypography-root": {
                    fontSize: "13px",
                  },
                }}
              />
            </ListItemButton>
          </NestedListItem>
        ))}
      </Collapse>
    </>
  );
};

export default SidebarMenu;
